var map = {
	"./": 10166,
	"./assets/team1.jpg": 13280,
	"./assets/team2.jpg": 10543,
	"./assets/team3.jpg": 54514,
	"./assets/team4.jpg": 80001,
	"./assets/video_thumb.jpg": 19928,
	"./index": 10166,
	"./index.jsx": 10166,
	"./style.scss": 87767
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88680;